<div *transloco="let t">
<!-- Button -->
<button class="rounded-full hover:border hover:border-white hover:border-solid" [attr.mat-icon-button]="avatarSize === 'small' ? '' : null" [matMenuTriggerFor]="userActions" >
    <span class="relative block">
        @if (showAvatar && user.avatar_url) {
            <img
                class=" rounded-full "
                [src]="user.avatar_url"
            [ngClass]="{
                'h-9 w-9': avatarSize === 'small',
                'h-12 w-12': avatarSize === 'medium',
                'h-16 w-16': avatarSize === 'large',
            }"
            />
        }
        @if (!showAvatar || !user.avatar_url) {
            <mat-icon [svgIcon]="'feather:user'"
                      [ngClass]="{
                        'h-9 w-9': avatarSize === 'small',
                        'h-12 w-12': avatarSize === 'medium',
                        'h-16 w-16': avatarSize === 'large',
                    }"
                      class="text-gray-900 bg-gray-500 rounded-full p-2">
                </mat-icon>
        }
        <span
            class="absolute bottom-0 left-auto right-0 border border-white dark:border-slate-900 border-solid rounded-full"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user.avatar_url,
                'bg-green-500': user.status === 'online',
                'bg-amber-500': user.status === 'away',
                'bg-red-500': user.status === 'busy',
                'bg-gray-400': user.status === 'not-visible',
                'hidden': !user.status,
                'h-3 w-3': avatarSize === 'small' || avatarSize === 'medium',
                'h-5 w-5': avatarSize === 'large',
            }"
        ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu" >
    <button mat-menu-item >
        <span class="flex flex-col leading-none">
            <span>{{ t('signed_in_as') }}</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="navigateToSettings()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{ t('profile') }}</span>
    </button>
    <!--button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>
    </button-->
    <!-- <button mat-menu-item [matMenuTriggerFor]="userStatus">
        <mat-icon
            [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"
        ></mat-icon>
        <span>{{ t('status') }}</span>
    </button> -->
    <button mat-menu-item [matMenuTriggerFor]="userLanguages">
        <mat-icon
            [svgIcon]="'heroicons_outline:globe-alt'"
        ></mat-icon>
        <span>{{ t('languages') }}</span>
    </button>
    <button mat-menu-item (click)="toggleFullscreen()" class="hidden md:flex">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrows-pointing-out'"
        ></mat-icon>
        <span>{{ t('toggle_fullscreen') }}</span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>{{ t('sign_out') }}</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>{{ t('online') }}</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>{{ t('away') }}</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>{{ t('busy') }}</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>{{ t('invisible') }}</span>
    </button>
</mat-menu>

<mat-menu class="user-languages-menu" #userLanguages="matMenu">
    @for (lang of availableLangs; track trackByFn($index, lang)) {
        <button mat-menu-item (click)="setActiveLang(lang.id)">
            <span class="flex items-center">
                <ng-container
                    *ngTemplateOutlet="
                        flagImage;
                        context: { $implicit: lang.id }
                    "
                ></ng-container>
                <span class="ml-3">{{ lang.label }}</span>
            </span>
        </button>
    }
</mat-menu>

<ng-template let-lang #flagImage>
    <span class="relative w-6 overflow-hidden rounded-sm shadow">
        <span
            class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
        ></span>
        <img
            class="w-full"
            [src]="'images/flags/' + flagCodes[lang].toUpperCase() + '.svg'"
            [alt]="'Flag image for ' + lang"
        />
    </span>
</ng-template>
</div>
